import { Map, fromJS } from 'immutable';

export function request(state) {
    return state.set(
        'data',
        (state.get('data') || Map())
            .set('state', 'IN_PROGRESS')
            .set('errors', void 0)
    );
}

export function error(state, { errors }) {
    return state.set(
        'data',
        (state.get('data') || Map())
            .set('state', 'ERROR')
            .set('errors', fromJS(errors))
    );
}

export function finish(state, { languages}) {
    return state.set(
        'data',
        (state.get('data') || Map())
            .set('list', languages)
            .set('errors', void 0)
            .set('state', 'FINISHED')
    );
}

